// Gift cards — capa de API de la pantalla de administración. El wrapper HTTP (1002, motivo de
// negocio en el mensaje) vive en `apiClient.js`; acá quedan sólo los endpoints.
//
// La venta y el uso NO pasan por acá: van en el body de `purchase` y `purchase/calculatePrice`
// desde `AddPurchasePage`, como el resto de la venta de mostrador.

import { get, post, patch } from './apiClient';
import { buildPaginationQuery } from './pagination';

// → { items, total, page, limit, totalPages }. `status` ∈ activa|usada|canjeada|anulada|vencida|trabadas|''.
// `origin` ∈ venta|premio|cortesia|''; `eventId` filtra los premios de un evento.
export const listar = ({ page = 1, limit = 25, search = '', status = '', origin = '', eventId = '' } = {}) =>
    get(`gift-cards?${buildPaginationQuery({ page, limit, search, extraParams: { status, origin, eventId } })}`);

// → tarjeta + salePurchase { purchaseId, date, cedula, status } + usePurchase (o null).
export const detalle = (id) => get(`gift-cards/${encodeURIComponent(id)}`);

// Canje entero a saldo a favor de la cédula (FR-050) → { card, amount, balance }.
export const canjear = (code, cedula) => post('gift-cards/redeem', { code, cedula });

// Canje repartido entre varias cédulas (backend spec-premios-cortesias FR-005):
// `splits` = [{ cedula, amount }] que suman el monto de la tarjeta → { card, amount, splits }.
export const canjearRepartido = (code, splits) => post('gift-cards/redeem', { code, splits });

// Premio de un evento o cortesía: tarjetas de plata sin venta (FR-001) → { giftCards: [...] }.
// body = { origin: 'premio'|'cortesia', eventId?, amount, quantity, reason, responsable }.
export const emitir = (body) => post('gift-cards/issue', body);

// Anulación de una activa sin usar (FR-070); el motivo es obligatorio.
export const anular = (id, reason) => patch(`gift-cards/${encodeURIComponent(id)}/cancel`, { reason });
